module.exports = __webpack_public_path__ + "static/assets/239fdd09203ed81f087e02904e571d2a.jpg";